<template>
  <v-navigation-drawer
      :width="390"
      :rail="rail"
      rail-width="48"
      location="left"
      :permanent="false"
      :expand-on-hover="$vuetify.display.width <= 1440"
      color="#3254B9"
      hide-overlay
  >
    <LeftMenuPrepend/>
    <LeftMenuAppend/>
    <template v-slot:append>
      <LeftMenuSocial v-show="!rail"/>
    </template>
    <div class="arrow">
      <v-icon
          size="100"
          @click="rail = !rail"
      >$custom_arrow</v-icon>
    </div>
  </v-navigation-drawer>
</template>

<script>
import LeftMenuPrepend from "@/modules/personal_account/menus/left_menu/LeftMenuPrepend.vue"
import LeftMenuAppend from "@/modules/personal_account/menus/left_menu/LeftMenuAppend.vue"
import LeftMenuSocial from "@/modules/personal_account/menus/left_menu/LeftMenuSocial.vue"

export default {
  name: 'LeftMenu',
  components: { LeftMenuSocial, LeftMenuAppend, LeftMenuPrepend },
  data () {
    return {
      rail: false
    }
  },
  computed: {
  },
  created () {
    if (this.$vuetify.display.width <= 1440) {
      this.rail = true
    }
  }
}

</script>

<style scoped lang="scss">
.arrow {
  cursor: pointer;
  position: absolute;
  top: 50px;
  right: -50px;

  &:hover {
    scale: 1.05;
    transition: scale linear .2s;
  }
}

@media screen and (max-width: 1560px) {
  .arrow {
    top: 25px;
    right: -50px;
  }
}
</style>
